import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";

const addRewardPointConfigurations = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("reward_point", data.reward_point);
    formdata.append("reward_amount", data.reward_amount);
    formdata.append("redemption_point", data.redemption_point);
    formdata.append("redemption_amount", data.redemption_amount);

    const res = await baseAPI.post(`/reward-point-configurations`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getCustomerRedeemOffers = async (data) => {
  // try {
    const formdata = new FormData();
    formdata.append("start_date", data.start_date);
    formdata.append("end_date", data.end_date);
    formdata.append("type", data.type);

    const res = await baseAPI.post(`/merchant-redeem-transaction`, formdata, {
      headers: authHeader(),
    });
    return res?.data;
  // } catch (error) {
  //   console.log(error);
  //   return error
  // }
};

const LoyaltyProgramService = {
  addRewardPointConfigurations,
  getCustomerRedeemOffers,
};

export default LoyaltyProgramService;
